import ErrorLayoutPage from "layout/ErrorLayoutPage";
import { useTranslation } from "react-i18next";

function NotAllowedPage() {
  const { t } = useTranslation("error");

  return (
    <ErrorLayoutPage
      errorCode={401}
      title={t("page.notAllowed.title")}
      description={t("page.notAllowed.description")}
    />
  );
}

export default NotAllowedPage;
